import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { TextField } from '@mui/material';

import { errorHandler } from './formUtils';

const FormBreakTime = ({ fieldErrorData, input, label, meta }) => {
  const error = errorHandler(input, meta, fieldErrorData);

  const handleTextFieldValue = (value) => {
    if (value === 0) {
      return value;
    }
    return input.value ? input.value : '';
  };

  return (
    <TextField
      error={!!error}
      id="form-break-input"
      focused
      helperText={(error && LanguageConverter(error)) || null}
      label={label}
      value={handleTextFieldValue(input.value)}
      onChange={input.onChange}
      sx={{ width: '100px' }}
    />
  );
};
FormBreakTime.propTypes = {
  label: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
      PropTypes.bool,
      PropTypes.number,
    ]),
  }),
  meta: PropTypes.shape(),
  sx: PropTypes.shape({}),
  fieldErrorData: PropTypes.string,
};

export default FormBreakTime;
